import type {Mapper} from 'framework';
import {GENDERS, type Gender} from '../../domain/gender.value-object';
import type {UserProfile} from '../../domain/user-profile';
import type {ProfileDto} from '../dto/settings.dto';

const GENDER_SET: ReadonlySet<string> = new Set(GENDERS);

const toDate = (value: string | Date): Date =>
  value instanceof Date ? value : new Date(value);

const toGender = (value: string | null): Gender | null => {
  if (value === null || !GENDER_SET.has(value)) {
    return null;
  }
  return GENDERS.find(gender => gender === value) ?? null;
};

export class ProfileDtoToUserProfileMapper implements Mapper<ProfileDto, UserProfile> {
  transform(dto: ProfileDto): UserProfile {
    return {
      userId: dto.userId,
      displayName: dto.displayName,
      timezone: dto.timezone,
      preferredFoodWeightUnit: dto.preferredFoodWeightUnit,
      preferredBodyWeightUnit: dto.preferredBodyWeightUnit,
      preferredHeightUnit: dto.preferredHeightUnit,
      preferredWaterUnit: dto.preferredWaterUnit,
      imageRetentionPolicy: dto.imageRetentionPolicy,
      birthdate: dto.birthdate,
      gender: toGender(dto.gender),
      heightCm: dto.heightCm,
      weightKg: dto.weightKg,
      avatarUrl: dto.avatarUrl ?? null,
      createdAt: toDate(dto.createdAt),
      updatedAt: toDate(dto.updatedAt),
    };
  }
}
